export default __webpack_public_path__ + "static/media/link.227e28c2.svg";